(() => {
  const ROOT_SELECTOR = '[data-japotyle-checkout-confirmations]';
  const CHECKBOX_SELECTOR = '[data-japotyle-cart-confirmation]';
  const ITEM_SELECTOR = '[data-japotyle-confirmation-item]';
  const CHECKOUT_SELECTOR = [
    '.japotyle-cart-template button[name="checkout"]',
    '.japotyle-cart-template input[name="checkout"]',
    '.japotyle-cart-template a[href*="/checkout"]'
  ].join(',');
  const DYNAMIC_CHECKOUT_SELECTOR = [
    '.japotyle-cart-template .cart__dynamic-checkout-buttons',
    '.japotyle-cart-template .additional-checkout-buttons'
  ].join(',');

  const roots = () => Array.from(document.querySelectorAll(ROOT_SELECTOR));
  const checkboxes = (root) => Array.from(root.querySelectorAll(CHECKBOX_SELECTOR));

  const messageFromTemplate = (template, confirmed, total) => String(template || '')
    .replaceAll('__CONFIRMED__', String(confirmed))
    .replaceAll('__TOTAL__', String(total));

  const confirmationComplete = () => {
    const activeRoots = roots();
    return activeRoots.length > 0 && activeRoots.every((root) => {
      const inputs = checkboxes(root);
      return inputs.length > 0 && inputs.every((input) => input.checked);
    });
  };

  const setButtonLocked = (button, locked, statusId) => {
    if (locked) {
      if (!button.hasAttribute('data-japotyle-was-disabled')) {
        button.dataset.japotyleWasDisabled = button.hasAttribute('disabled') ? 'true' : 'false';
      }
      button.setAttribute('disabled', '');
      button.setAttribute('aria-disabled', 'true');
      button.setAttribute('data-japotyle-confirmation-locked', 'true');
      if (statusId) button.setAttribute('aria-describedby', statusId);
      return;
    }

    if (button.dataset.japotyleWasDisabled === 'false') button.removeAttribute('disabled');
    const wasDisabled = button.dataset.japotyleWasDisabled === 'true';
    button.removeAttribute('data-japotyle-was-disabled');
    button.removeAttribute('data-japotyle-confirmation-locked');
    if (!wasDisabled && button.getAttribute('aria-disabled') === 'true') button.removeAttribute('aria-disabled');
    if (statusId && button.getAttribute('aria-describedby') === statusId) {
      button.removeAttribute('aria-describedby');
    }
  };

  const associateWithCheckoutForm = (root) => {
    const button = document.querySelector('.japotyle-cart-template button[name="checkout"]');
    const form = button?.form;
    if (!form) return;

    if (!form.id) form.id = 'JapotyleCartCheckoutForm';
    checkboxes(root).forEach((input) => input.setAttribute('form', form.id));
  };

  const sync = () => {
    const activeRoots = roots();
    if (!activeRoots.length) return;

    activeRoots.forEach((root) => {
      const inputs = checkboxes(root);
      const confirmed = inputs.filter((input) => input.checked).length;
      const complete = inputs.length > 0 && confirmed === inputs.length;
      const status = root.querySelector('[data-japotyle-confirmation-status]');

      root.classList.toggle('is-complete', complete);
      root.querySelectorAll(ITEM_SELECTOR).forEach((item) => {
        const checked = Boolean(item.querySelector(CHECKBOX_SELECTOR)?.checked);
        item.classList.toggle('is-confirmed', checked);
      });

      if (status) {
        status.classList.remove('is-error');
        const nextMessage = complete
          ? root.dataset.completeMessage
          : messageFromTemplate(root.dataset.progressTemplate, confirmed, inputs.length);
        if (status.textContent !== nextMessage) status.textContent = nextMessage;
      }

      associateWithCheckoutForm(root);
    });

    const complete = confirmationComplete();
    const statusId = activeRoots[0].querySelector('[data-japotyle-confirmation-status]')?.id || '';
    document.querySelectorAll(CHECKOUT_SELECTOR).forEach((button) => {
      setButtonLocked(button, !complete, statusId);
      button.classList.toggle('japotyle-checkout-confirmation-locked', !complete);
    });
    document.querySelectorAll(DYNAMIC_CHECKOUT_SELECTOR).forEach((wrapper) => {
      wrapper.classList.toggle('japotyle-checkout-confirmation-locked', !complete);
      wrapper.setAttribute('aria-hidden', String(!complete));
    });
  };

  const showRequiredMessage = () => {
    const root = roots()[0];
    if (!root) return;
    const status = root.querySelector('[data-japotyle-confirmation-status]');
    if (status) {
      status.textContent = root.dataset.requiredMessage;
      status.classList.add('is-error');
    }
    const firstUnchecked = checkboxes(root).find((input) => !input.checked);
    root.scrollIntoView({ behavior: 'smooth', block: 'center' });
    window.setTimeout(() => firstUnchecked?.focus({ preventScroll: true }), 350);
  };

  const reset = () => {
    roots().forEach((root) => {
      checkboxes(root).forEach((input) => { input.checked = false; });
    });
    sync();
  };

  const start = () => {
    roots().forEach((root) => {
      checkboxes(root).forEach((input) => {
        input.checked = false;
        input.addEventListener('change', sync);
      });
    });

    document.addEventListener('click', (event) => {
      const checkout = event.target.closest(`${CHECKOUT_SELECTOR}, ${DYNAMIC_CHECKOUT_SELECTOR}`);
      if (!checkout || confirmationComplete()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      showRequiredMessage();
    }, true);

    document.addEventListener('submit', (event) => {
      const submitter = event.submitter;
      if (!submitter?.matches?.(CHECKOUT_SELECTOR) || confirmationComplete()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      showRequiredMessage();
    }, true);

    const observer = new MutationObserver(sync);
    observer.observe(document.body, { childList: true, subtree: true });

    if (
      typeof subscribe === 'function'
      && typeof PUB_SUB_EVENTS !== 'undefined'
      && typeof PUB_SUB_EVENTS.cartUpdate === 'string'
    ) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, reset);
    }
    document.addEventListener('japotyle:cart-updated', reset);
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) reset();
    });

    sync();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
